var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG3159(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.335,
    height: 89.335,
    viewBox: "0 0 89.335 89.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3165",
    d: "M0-682.665H89.335v89.335H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3159",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3161",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3163",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3169",
    transform: "translate(13.831 13.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3171",
    d: "M-363.068,0h-47.657a7.029,7.029,0,0,0-7.008,7.008V72.887h61.674V7.008A7.029,7.029,0,0,0-363.068,0Z",
    transform: "translate(417.734)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3173",
    transform: "translate(25.044 2.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3175",
    d: "M0-74.476v-4.205a7.029,7.029,0,0,1,7.008-7.008h25.23a7.029,7.029,0,0,1,7.008,7.008v4.205",
    transform: "translate(0 85.689)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3177",
    transform: "translate(33.454 69.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3179",
    d: "M0-111.713v-9.812a7.029,7.029,0,0,1,7.008-7.008h8.41a7.029,7.029,0,0,1,7.008,7.008v9.812",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3181",
    transform: "translate(44.667 69.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3183",
    d: "M0-111.713v-16.82",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3185",
    transform: "translate(27.847 25.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3187",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3189",
    transform: "translate(39.061 25.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3191",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3193",
    transform: "translate(27.847 36.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3195",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3197",
    transform: "translate(39.061 36.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3199",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3201",
    transform: "translate(27.847 47.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3203",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3205",
    transform: "translate(39.061 47.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3207",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3209",
    transform: "translate(27.847 58.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3211",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3213",
    transform: "translate(39.061 58.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3215",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3217",
    transform: "translate(50.274 25.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3219",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3221",
    transform: "translate(61.488 25.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3223",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3225",
    transform: "translate(50.274 36.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3227",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3229",
    transform: "translate(61.488 36.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3231",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3233",
    transform: "translate(50.274 47.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3235",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3237",
    transform: "translate(61.488 47.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3239",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3241",
    transform: "translate(50.274 58.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3243",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3245",
    transform: "translate(61.488 58.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3247",
    d: "M0,0H0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG3159);
export default __webpack_public_path__ + "static/media/g3159.9a586c389b5debef01ccb1a366ed87da.svg";
export { ForwardRef as ReactComponent };